import React from 'react'
import Header from '../../common/Header'
import CommonHeroSection from '../../common/CommonHeroSection'
import CommonBreadcrumb from '../../common/CommonBreadcrumb'
import DynamicTourSection from '../../sections/CommonSection/DynamicToureSection'
import Footer from '../../common/Footer'
import { coorgHomeStayData } from './tourPackageData'

function CoorgHomeStay() {
    return (
        <>
            <Header />
            <CommonHeroSection title="Coorg With Home Stay" />
            <CommonBreadcrumb items={["Coorg With Home Stay"]} />
            <DynamicTourSection {...coorgHomeStayData} />
            <Footer />
        </>
    )
}

export default CoorgHomeStay
